var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
        [
          _c(
            "c-table",
            {
              ref: "userGrid",
              attrs: {
                title: "LBL0002821",
                columns: _vm.userGrid.columns,
                gridHeight: _vm.gridHeight,
                data: _vm.userGrid.data,
                filtering: false,
                isFullScreen: false,
                checkClickFlag: false,
                columnSetting: false,
                usePaging: false,
                isExcelDown: false,
                editable: _vm.editable,
                rowKey: "userId",
                selection: "multiple",
              },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "LBLADD", icon: "add" },
                            on: { btnClicked: _vm.addUser },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.userGrid.data.length > 0
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLREMOVE",
                              showLoading: false,
                              icon: "remove",
                            },
                            on: { btnClicked: _vm.removeUser },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
        [
          _c(
            "c-table",
            {
              ref: "deptGrid",
              attrs: {
                title: "LBL0002822",
                columns: _vm.deptGrid.columns,
                gridHeight: _vm.gridHeight,
                data: _vm.deptGrid.data,
                filtering: false,
                isFullScreen: false,
                checkClickFlag: false,
                columnSetting: false,
                usePaging: false,
                isExcelDown: false,
                editable: _vm.editable,
                rowKey: "deptCd",
                selection: "multiple",
              },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "LBLADD", icon: "add" },
                            on: { btnClicked: _vm.addDept },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.deptGrid.data.length > 0
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLREMOVE",
                              showLoading: false,
                              icon: "remove",
                            },
                            on: { btnClicked: _vm.removeDept },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
        [
          _c(
            "c-table",
            {
              ref: "seniorGrid",
              attrs: {
                title: "LBL0002823",
                columns: _vm.seniorGrid.columns,
                gridHeight: _vm.gridHeight,
                data: _vm.seniorGrid.data,
                filtering: false,
                isFullScreen: false,
                checkClickFlag: false,
                columnSetting: false,
                usePaging: false,
                isExcelDown: false,
                editable: _vm.editable,
                rowKey: "seniorId",
                selection: "multiple",
              },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "LBLADD", icon: "add" },
                            on: { btnClicked: _vm.addSenior },
                          })
                        : _vm._e(),
                      _vm.editable && _vm.seniorGrid.data.length > 0
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLREMOVE",
                              showLoading: false,
                              icon: "remove",
                            },
                            on: { btnClicked: _vm.removeSenior },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }